import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
// Components
import App from '../../../components/app';
import EnhancedTable from '../../../components/table';
// Modules
import { tableRequestPoints } from '../../../redux/reducers/constants';
import { FormatType, HeadCell } from '../../../local-types';
import { Cell, createCell } from '../../../components/table/table-cell-creator';
// Ressources

interface RidersListProps extends WithTranslation {}

class RidersListPage extends React.Component<RidersListProps> {
    headerBuilder = (): HeadCell[] => {
        const { t } = this.props;
        const headers: HeadCell[] = [
            createCell(t, Cell.ID, { sortable: true }),
            createCell(t, Cell.FULLNAME),
            createCell(t, Cell.EMAIL),
            createCell(t, Cell.PHONE_NUMBER),
            {
                id: 'subscription_date',
                label: t('subscription_date'),
                type: FormatType.DateShort,
                filterable: false,
            },
            // {
            //     id: 'total_net_price_without_vat_generated_recently',
            //     type: FormatType.Price,
            //     label: t('total_net_30'),
            //     filterable: false,
            // },
            // {
            //     id: 'total_net_price_without_vat',
            //     type: FormatType.Price,
            //     label: t('total_net'),
            //     filterable: false,
            // },
            createCell(t, Cell.COMPANY, { id: 'active_company_membership.company.name' }),
        ];
        return headers;
    };

    render() {
        const { t } = this.props;

        return (
            <App
                disableBreadcrumb
                header={{
                    title: t('title'),
                    subtitle: t('description'),
                }}
            >
                <EnhancedTable headers={this.headerBuilder()} type={tableRequestPoints.RIDERS} />
            </App>
        );
    }
}

export default withTranslation(['rider', 'common'])(RidersListPage);
